import React, { useState,useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import VizSensor from "react-visibility-sensor";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
  TableRow,
  TableSortLabel ,
  TablePagination,
  Typography,
  IconButton,  
  Button,
  Paper
} from "@material-ui/core";
import CountProductsInGroup from "./CountProductsInGroup";
import CountBannersInGroup from "./CountBannersInGroup";
import EditActualSizeTextBox from "./EditActualSizeTextBox";
import EditCountValueTextBox from "./EditCountValueTextBox";
import ButtonRemoveBProduct from "./ButtonRemoveBProduct";
import ButtonMoveBProduct from "./ButtonMoveBProduct";
import ProductImage from "../../Common/ProductImage";
// import BProductsAndCompetitorPanel from "./Products/BProductsAndCompetitorPanel";


import { useSelector } from "react-redux";
import axios from "axios";
import envConfig from "../../../bin/env.config";
import ProductAttributesInfo from "../../Product/ProductAttributesInfo";
import Tags from "../../Tags/Tags";
const useStyles = makeStyles((theme) => ({
  productImage: {
    width: 50,
    height: 50,
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      width: 25,
      height: 25,
    },
    cursor: "pointer",
  },
  productName: {
    textDecoration: 'none',
    color: theme.palette.secondary.main,
    cursor: "pointer"
  },
  removeButton: {
    color: "red",
    borderColor: "red",
  },
}));
export default function BProductsPanel({item,reloadDataCount,searchText,projectId}) {  
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [reloadDataLocal, setReloadDataLocal] = useState(reloadDataCount);
  const [dataSource, setDataSource] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState('prj.id');
  const [order, setOrder] = useState('asc');
  const token = useSelector((state) => state.session.token);
  const [isVisible, setIsVisible] = useState(false);
  const doLoadData = (isVisibleChanged) => {
    isVisibleChanged&&setIsVisible(isVisibleChanged)    
  };  
  
  // const handleAddMoreMatch = (_product_id)=>{
  //   window.open(`/matching-potential-4project/${_product_id}/${projectId}`);
  // } 

  const handleCreateAndMatch = (productMatchingGroupID)=>{
    window.open(`/matching-group/${productMatchingGroupID}`);
  } 
  const removeItem=(i)=>{   
    setReloadDataLocal(reloadDataLocal+1)
  }
  const moveItem=(i)=>{   
    setReloadDataLocal(reloadDataLocal+1)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    setPage(0);
  };

  // Reset page when search text changes
  useEffect(() => {
    setPage(0);
  }, [searchText]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const skip = page * rowsPerPage;
      const params = new URLSearchParams({
        id: item.id,
      });
      if (searchText) {
        params.append('q', searchText);
      }
      params.append('skip', skip.toString());
      params.append('limit', rowsPerPage.toString());
      params.append('orderBy', orderBy);
      params.append('order', order);
      
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/product/detail?${params.toString()}`;
      const result = await axios.post(url, {}, {
        headers: {
          Authorization: token,
        },
      });
      // console.log(result.data.data)
      setDataSource(result.data.data || []);
      // If API returns total count, use it; otherwise use data length
      if (result.data.total !== undefined) {
        setTotalCount(result.data.total);
      } else {
        setTotalCount(result.data.data?.length || 0);
      }
      setIsLoading(false);
    };
    isVisible&&fetchData();

    // if (searchText.length > 0) {
    //   let dataSourceTemp = products.filter(function(product) {
    //     if (product.productMatchingGroup&&
    //       (product.productMatchingGroup.fullname.toLowerCase().includes(searchText.toLowerCase())||
    //       (product.productMatchingGroup.id.toString()===searchText.toString()))
    //     )  {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   });
    //   setDataSource([...dataSourceTemp]);
    // } else {
    //   setDataSource([...products]);
    // }
  }, [searchText,item,reloadDataLocal,isVisible,reloadDataCount,page,rowsPerPage,orderBy,order]);
  
  return (
      <VizSensor partialVisibility onChange={doLoadData}>    
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{width:'20px'}} align="center">
                  #
                </TableCell>
                <TableCell style={{width:'16px'}} align="center">
                  {/* Remove button column */}
                </TableCell>
                <TableCell style={{width:'16px'}} align="center">
                  {/* Move button column */}
                </TableCell>
                <TableCell style={{width:'80px'}}>
                  Image
                </TableCell>
                <TableCell style={{width:'50px'}}>
                  <TableSortLabel
                    active={orderBy === 'prj.id'}
                    direction={orderBy === 'prj.id' ? order : 'asc'}
                    onClick={() => handleSort('prj.id')}
                  >
                    ID
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'pmg.fullname'}
                    direction={orderBy === 'pmg.fullname' ? order : 'asc'}
                    onClick={() => handleSort('pmg.fullname')}
                  >
                    Product Name
                  </TableSortLabel>
                </TableCell>
                <TableCell style={{width:'200px'}}>
                  <TableSortLabel
                    active={orderBy === 'pmg.brand_name'}
                    direction={orderBy === 'pmg.brand_name' ? order : 'asc'}
                    onClick={() => handleSort('pmg.brand_name')}
                  >
                    Brand
                  </TableSortLabel>
                </TableCell>
                <TableCell style={{width:'80px'}}>
                  Count Value
                </TableCell>
                <TableCell style={{width:'120px'}}>
                  Actual Size
                </TableCell>
                <TableCell style={{width:'160px'}} align="left">
                  Counts
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody> 
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : dataSource.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No product matching group 
                </TableCell>
              </TableRow>
            ) : (
              dataSource.map((item, i) => (               
                <TableRow key={i}>
                  <TableCell style={{width:'20px'}} align="center">
                    {page * rowsPerPage + i + 1}
                  </TableCell>
                <TableCell style={{width:'16px'}} align="center">
                    <ButtonRemoveBProduct item={item} removeItem={i=>removeItem(i)}/> 
                </TableCell>
                <TableCell style={{width:'16px'}} align="center">
                    <ButtonMoveBProduct item={item} projectId={projectId} moveItem={i=>moveItem(i)}/> 
                </TableCell>
                <TableCell style={{width:'80px'}}>
                   <ProductImage  product_matching_group_id={item.productMatchingGroup.id} 
                      title={item.productMatchingGroup.name} width={'50px'} height={'50px'} hide_multiple_icon="true"
                    />
                </TableCell>
                <TableCell style={{width:'50px'}}>
                  {/* <Button  variant="outlined" color="primary" onClick={()=>handleAddMoreMatch(item.productMatchingGroup._product_id)}> */}
                  <Button  variant="outlined" color="primary" onClick={()=>handleCreateAndMatch(item.productMatchingGroup.id)}>
                  {item.productMatchingGroup.id}
                  </Button>
                  
                </TableCell>
                <TableCell >
                  <div>{item.productMatchingGroup.fullname}</div>
                  <div>{item.productMatchingGroup.size}</div>
                  <ProductAttributesInfo productId={item.productMatchingGroup.product_id}/>
                  <Tags productMatchingGroupId={item.productMatchingGroup.id}/>
                </TableCell>            
                <TableCell style={{width:'200px'}}>
                  {item.productMatchingGroup.brand_name}
                </TableCell>
                <TableCell style={{width:'80px'}}>
                  <EditCountValueTextBox id={item.id} value={item.count_value}/>
                </TableCell>
                <TableCell style={{width:'120px'}}>
                  <EditActualSizeTextBox id={item.id} value= {item.actual_size}/>
                </TableCell>  
                <TableCell style={{width:'160px'}} align="left">
                  <CountProductsInGroup productMatchingGroupId={item.productMatchingGroup.id}/> 
                  <CountBannersInGroup productMatchingGroupId={item.productMatchingGroup.id}/>
                </TableCell>
                                    
                </TableRow>
              ))
            )}

          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
        </TableContainer>
    </VizSensor>   
  );
}
